import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';
import {
  IGetDataPayload,
  IRuleAddEditPayload,
} from '@app/dashboard/types/innerLayout/risk_center';

export const getRulesListData = (data: IGetDataPayload) => {
  const { params, currentPage, pageSize, ...rest } = data;
  const payload = {
    ...rest,
    ...params,
    page: currentPage,
    page_size: pageSize,
  };

  return axiosPrivate.get(`/dashboard/api/v1/risk-center/rules`, {
    params: payload,
  });
};

export const getModalRuleData = (isLive: boolean) => {
  return axiosPrivate.get(`/dashboard/api/v1/risk-center/rules/modal`, {
    params: { isLive },
  });
};

export const addRule = (payload: IRuleAddEditPayload) => {
  return axiosPrivate.post(`/dashboard/api/v1/risk-center/rules`, payload);
};

export const removeRule = (id: number) => {
  return axiosPrivate.delete(`/dashboard/api/v1/risk-center/rules/${id}`);
};

export const editRule = (id: number, payload: IRuleAddEditPayload) => {
  return axiosPrivate.put(`/dashboard/api/v1/risk-center/rules/${id}`, payload);
};
